import React from 'react'

import { Box } from '~/components/elements/Box'
import { Typography } from '~/components/elements/Typography'
import { FigureInfoHelpers, type FigureInfoOverlapGroupFilter } from '~/utils'

import styles from './FigureInfoOverlapGroupFilters.css'

export type FigureInfoOverlapGroupFiltersProps = {
  overlapGroupFilters: FigureInfoOverlapGroupFilter[]
}

export const FigureInfoOverlapGroupFilters = ({
  overlapGroupFilters,
}: FigureInfoOverlapGroupFiltersProps) => {
  const table = React.useMemo(
    () => FigureInfoHelpers.toOverlapGroupFiltersTextTable(overlapGroupFilters),
    [overlapGroupFilters],
  )

  return (
    <Box className={styles.root}>
      {table.map((line, row) => (
        <React.Fragment key={row}>
          {line.map((cell, column) => (
            <Typography key={column} variant="normal">
              {cell}
            </Typography>
          ))}
        </React.Fragment>
      ))}
    </Box>
  )
}
